import { Component, Input, OnInit } from '@angular/core';
import { Avis } from 'src/app/avis/models/Avis';

@Component({
  selector: 'app-item-avis',
  templateUrl: './item-avis.component.html',
  styleUrls: ['./item-avis.component.scss']
})
export class ItemAvisComponent implements OnInit {

    @Input()avis: Avis;

    constructor() { }

    ngOnInit(): void {
    }

    /**
     * Récupérer la première lettre du nom de l'auteur de l'avis
     * @returns 
     */
    getFirstLetter(): string {
        return this.avis.author[0];
    }

    /**
     * racourcir le contenu et le renvoyer pour l'afficher dans les cartes
     */
    getShortContent(): string {
        if(this.avis.content.length > 100) {
            return this.avis.content.slice(0,100) + "...";
        }
        return this.avis.content;
    }
}
